interface StepOneProps {
  nextStep: () => void;
  reason: string;
  comment: string;
  setReason: (value: string) => void;
  setComment: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const StepOne = ({ nextStep, reason, comment, setReason, setComment }: StepOneProps) => (
  <div>
    <div className="font-medium text-sm text-black leading-tight mb-2">
      ¿Por qué decidiste cancelar tu plan Holos?
    </div>
    
    <select
      name="type"
      className="w-full p-3 border border-gray-300 rounded-lg"
      onChange={(e) => setReason(e.target.value)}
      value={reason}
    >
      <option value="">Seleccionar</option>
      <option value="Me voy de viaje">Me voy de viaje</option>
      <option value="Quiero ir a un solo centro">Quiero ir a un solo centro</option>
      <option value="No tengo presupuesto">No tengo presupuesto</option>
      <option value="No encuentro centros cerca de mi">No encuentro centros cerca de mi</option>
      <option value="Tuve una mala experiencia con la plataforma">Tuve una mala experiencia con la plataforma</option>
      <option value="Tuve una mala experiencia con un partner">Tuve una mala experiencia con un partner</option>
      <option value="No lo usé lo suficiente">No lo usé lo suficiente</option>
      <option value="No tuve tiempo de utilizarla">No tuve tiempo de utilizarla</option>
      <option value="Me enfermé">Me enfermé</option>
      <option value="Me metí de curioso">Me metí de curioso</option>
      <option value="No era lo que esperaba">No era lo que esperaba</option>
      <option value="No sabía usarlo">No sabía usarlo</option>
      <option value="No tengo interés">No tengo interés</option>
      <option value="No está el deporte que me gusta">No está el deporte que me gusta</option>
      <option value="No hay clases grupales online en vivo">No hay clases grupales online en vivo</option>
      <option value="Tuve un problema con un centro o profesional">Tuve un problema con un centro o profesional</option>
      <option value="Me inscribí con un partner directamente">Me inscribí con un partner directamente</option>
      <option value="Otro">Otro</option>
    </select>
    
    {reason === 'Otro' && (
      <div className="mt-3">
        <textarea
          className="w-full p-3 border border-gray-300 rounded-lg h-40 resize-none"
          maxLength={250}
          name="comment"
          value={comment}
          onChange={setComment}
          placeholder="Ingresa algún comentario o motivo extra"
        />
      </div>
    )}
    
    <button
      className="w-full bg-holos-dark text-white py-3 px-4 rounded-lg font-semibold uppercase mt-3 hover:bg-holos-dark/80 disabled:opacity-50 cursor-pointer"
      onClick={nextStep}
      disabled={!reason || (reason === 'Otro' && comment.length <= 5)}
    >
      Siguiente
    </button>
  </div>
);